import React from 'react';
import Product from '../Product';


function Skirts () {
    return (
        <div>
            <div>
                <Product title="Skirts" start={0} end={5} />
            </div>
        </div>
    )
}

export default Skirts;